module.exports = __webpack_public_path__ + "static/media/7.3a9ebaa2.jpg";